import
{
    FormDataState,
    RegistrationData,
    LoginData,
    PasswordResetData,
    Stage1Data,
    Stage2Data
} from '@/contracts/store/FormDataContracts'

export const FormData =
{
    namespaced: true,
    state: (): FormDataState => (
    {
        registrationExists: false,
        registrationData: {} as RegistrationData,
        loginExists: false,
        loginData: {} as LoginData,
        passwordResetExists: false,
        passwordResetData: {} as PasswordResetData,
        stage1Exists: false,
        stage1Data: {} as Stage1Data,
        stage2Exists: false,
        stage2Data: {} as Stage2Data
    }),
    getters:
    {
        registrationExists(state: FormDataState): boolean
        {
            return state.registrationExists
        },
        registrationData(state: FormDataState): RegistrationData
        {
            return state.registrationData
        },
        loginExists(state: FormDataState): boolean
        {
            return state.loginExists
        },
        loginData(state: FormDataState): LoginData
        {
            return state.loginData
        },
        passwordResetExists(state: FormDataState): boolean
        {
            return state.passwordResetExists
        },
        passwordResetData(state: FormDataState): PasswordResetData
        {
            return state.passwordResetData
        },
        stage1Exists(state: FormDataState): boolean
        {
            return state.stage1Exists
        },
        stage1Data(state: FormDataState): Stage1Data
        {
            return state.stage1Data
        },
        stage2Exists(state: FormDataState): boolean
        {
            return state.stage2Exists
        },
        stage2Data(state: FormDataState): Stage2Data
        {
            return state.stage2Data
        }
    },
    mutations:
    {
        setRegistrationData(state: FormDataState, data: RegistrationData): void
        {
            state.registrationExists = true
            state.registrationData = data
        },
        resetRegistrationData(state: FormDataState): void
        {
            state.registrationExists = false
            state.registrationData = {} as RegistrationData
        },
        setLoginData(state: FormDataState, data: LoginData): void
        {
            state.loginExists = true
            state.loginData = data
        },
        setPasswordResetData(state: FormDataState, data: PasswordResetData): void
        {
            state.passwordResetExists = true
            state.passwordResetData = data
        },
        setStage1Data(state: FormDataState, data: Stage1Data): void
        {
            state.stage1Exists = true
            state.stage1Data = data
        },
        setStage2Data(state: FormDataState, data: Stage2Data): void
        {
            state.stage2Exists = true
            state.stage2Data = data
        },
        resetStageData(state: FormDataState): void
        {
            state.stage1Exists = false
            state.stage1Data = {} as Stage1Data
            state.stage2Exists = false
            state.stage2Data = {} as Stage2Data
        }
    }
}
